import styled from 'styled-components';

export const HowItWorksList = styled.ol`
  width: 100%;
  margin: 0;
  padding: 0;
  
  list-style: none;
  
  @media(min-width: 1024px) {
    display: flex;
    justify-content: space-between;
  }
`;

export const HowItWorksItem = styled.li`
  &:not(:last-child) {
    margin-bottom: 25px;
  }
  
  a {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
  
  @media(min-width: 700px) {
    &:not(:last-child) {
      margin-bottom: 30px;
    }
  }
  
  @media(min-width: 1024px) {
    width: 31.4%;
    height: 440px;
    
    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
`;
